import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { InboxComponent } from './inbox.component';
import { InboxRoutingModule } from './inbox-routing.module';
import { MyDatePickerModule } from 'mydatepicker';
@NgModule({
    declarations: [
        InboxComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        NgSelectModule,
        NgxUiLoaderModule,
        MaskedTextBoxModule,
        InboxRoutingModule,
        MyDatePickerModule

    ],
    exports :[InboxComponent],
    providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})
export class InboxModule { }
